/**
 *  额度管理
 */

import axios from 'axios';

axios.defaults.baseURL = websiteConfig.commonRequestUrl;

const token = getLocalStorage(websiteConfig.tokenStringName);
axios.defaults.headers = {
    'token': token,
    'content-type': 'application/json'
};

// 添加响应拦截器
axios.interceptors.response.use(function(res) {
    // 对响应数据做点什么
    if(res.data.code != 0){
    	 // $.userAlert(res.data.msg)
    }
    return res;
}, function(error) {
    // 对响应错误做点什么
    var jumpUrl=window.location.href.indexOf("/login.html")>=0;
    var status = error.response.status;
    if (status === 401) {
        alert("此用户未授权");
        removeLocalStorage(tkName);
        if(!jumpUrl){
            window.location.href = "login.html";
        }
    }
    else if (status === 500) {
        alert("系统异常");
    }
    else if (status === 502) {
        alert("禁止访问");
    }
    else if (status === 1000) {
        alert("用户已经存在");
    }
    else if (status === 1001) {
        alert("用户不存在");
    }
    else if (status === 1002) {
        alert("用户不可以解除");
    }
    else{
        alert("系统错误,请稍后再试");
    }
    return false;
});

// 查询额度配置
export const queryCreditInfo = params => { return axios.post('/wallet/queryCreditInfo', params)}

// 查询额度列表
export const queryCreditList = params => { return axios.post('/wallet/queryCreditList', params)}

// 查询额度变更记录
export const queryCreditChangeRecord = params => { return axios.post('/wallet/queryCreditChangeRecord', params)}

//获取验证图片资源
export const getDragVerification = params => { return axios.get('/user/login/getDragVerification', {params})}

//账号密码登录验证
export const validateAndLogin = params => { return axios.get('/user/login/validateAndLogin', {params})}

//手机号登录验证
export const getMobileVerificationCodeByVerification = params => { return axios.get('/user/login/getMobileVerificationCodeByVerification', {params})}

//注册账号验证
export const checkAndSendVerifyCode = params => { return axios.get('/user/regist/checkAndSendVerifyCode', {params})}

//忘记密码验证
export const checkoutAndSendVerifyCodeForFindPwd = params => { return axios.get('/user/findpwd/checkoutAndSendVerifyCodeForFindPwd', {params})}

//获取解除登陆限制短信验证码
export const getUnlockUserSmsCode = params => { return axios.get('/user/login/getUnlockUserSmsCode', {params})}

//通过短信验证码进行解锁
export const unlockUserBySmsCode = params => { return axios.get('/user/login/unlockUserBySmsCode', {params})}




// WEBPACK FOOTER //
// ./src/api/index.js